import React from "react";
import "../styles/AssessmentDetailsStyles.css";
import CommonUtils from "../../../utils/Common_Utils";
import { AssessmentEntity } from "../data/response/AssessmentStatusResponse";
import CustomTooltip from "../../../components/CustomToolTipComponents";
import { LocalStorage } from "../../../utils/Utils";
import CardQuesIcon from "../assets/allAssessment/cardQuesIcon.png";
import CardSubIcon from "../assets/allAssessment/cardSubIcon.png";
import CardClockIcon from "../assets/allAssessment/cardClockIcon.png";
import CardPositiveClock from "../assets/allAssessment/cardPositiveClock.svg";
import CardNegativeClock from "../assets/allAssessment/cardNegativeClock.svg";
import strings from "../../../utils/Strings";
type LeftPanelProps = {
  selectedAssessment: AssessmentEntity;
};
interface Props {
  percentage: number;
}

const CircularProgress: React.FC<Props> = ({ percentage }) => {
  return (
    <div className="circle-container">
      <div
        className="circle"
        style={{
          background: `conic-gradient(
            #D3D6D9 ${percentage * 3.6}deg,
            #FF3A3A 0deg
          )`,
        }}
      >
        <div className="inner-circle">
          <span>{percentage}%</span>
        </div>
      </div>
    </div>
  );
};
const formatTime = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};
const formatDuration = (totalMinutes: number) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) {
    return `${minutes.toString().padStart(2, "0")}:00`;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:00`;
};

const AssessmentDetailsComponent: React.FC<LeftPanelProps> = ({
  selectedAssessment,
}) => {
  //Assesment Time Detection
  const warningText = CommonUtils.getAssessmentTimeWarning(
    selectedAssessment,
    false,
  );

  console.log(selectedAssessment, "data$$$");
  const IsIndependentUser =
    LocalStorage.getLocalData("institute_id") === "null"; //No need to show remaining time for independent user
  const timeLeft = selectedAssessment?.assessment_entity_time_left || "0:00:00";
  return (
    <div className="left-panel">
      <div
        className={warningText ? "assessment-timeout-card" : "assessment-card"}
      >
        <div className="card-header">
          <div className="card-headercolumn">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px", // row-gap and column-gap
              }}
            >
              {selectedAssessment?.dimension_questions && (
                <span className="assessment-badge">JOZUNA</span>
              )}
              {selectedAssessment?.curriculum_questions && (
                <span className="assessment-badge">Industry</span>
              )}
              {selectedAssessment?.category_questions && (
                <span className="assessment-badge">Curriculum</span>
              )}
            </div>
            <CustomTooltip
              title={
                selectedAssessment?.assessment_entity_name?.length > 50
                  ? selectedAssessment.assessment_entity_name
                  : ""
              }
            >
              <h3 className="assessment-title">
                {selectedAssessment?.assessment_entity_name?.length > 50
                  ? selectedAssessment.assessment_entity_name.slice(0, 50) +
                    "..."
                  : selectedAssessment?.assessment_entity_name || ""}
              </h3>
            </CustomTooltip>
          </div>
          {/* {selectedAssessment.candidate_assessment_status ===
            strings.assessment_status.initated ||
            (selectedAssessment.candidate_assessment_status ===
              strings.assessment_status.inProgress && (
              <CircularProgress
                percentage={CommonUtils.getAssessmentCompletionPercentage({
                  currentCounter:
                    selectedAssessment!.current_counter === null
                      ? 0
                      : selectedAssessment!.current_counter,
                  totalQuestions: selectedAssessment.total_question,
                })}
              />
            ))} */}
        </div>

        <div className="meta">
          {IsIndependentUser === false && (
            <p className="time-left">
              <img
                src={(() => {
                  const timeLeft =
                    selectedAssessment?.assessment_entity_time_left ||
                    "0:00:00";
                  const [daysStr, hoursStr, minutesStr] = timeLeft.split(":");
                  const days = parseInt(daysStr);
                  const hours = parseInt(hoursStr);
                  const minutes = parseInt(minutesStr);

                  const isUrgent = days === 0 && hours === 0 && minutes > 0;

                  return isUrgent ? CardNegativeClock : CardPositiveClock;
                })()}
                alt="Clock Icon"
                className="clock-icon"
                style={{
                  width: "17px",
                  height: "17px",
                  marginRight: "6px",
                  verticalAlign: "start",
                }}
              />

              <span
                style={{
                  color: (() => {
                    const timeLeft =
                      selectedAssessment?.assessment_entity_time_left ||
                      "0:00:00";
                    const [days, hours, minutes] = timeLeft
                      .split(":")
                      .map(Number);
                    return days === 0 && hours < 1 && minutes > 0
                      ? "#FF3A3A"
                      : "#717579";
                  })(),
                  fontFamily: "Mazzard",
                  fontSize: "15px",
                }}
              >
                {CommonUtils.formatAssessmentTimeLeftV2(timeLeft)}
              </span>
            </p>
          )}
          <p>
            <img src={CardQuesIcon} alt="Questions" className="cardicon" />
            {selectedAssessment.status !== "Resume" ? (
              <>
                <CustomTooltip
                  title={
                    selectedAssessment.total_question > 10000000
                      ? selectedAssessment.total_question
                      : ""
                  }
                >
                  <span className="card-value">
                    {selectedAssessment.total_question}
                  </span>
                </CustomTooltip>
                <span className="card-label">{" Questions"}</span>
              </>
            ) : (
              <>
                {" "}
                <span className="card-value-highlisht">
                  {selectedAssessment.current_counter}
                </span>{" "}
                <span className="card-value">
                  / {selectedAssessment.total_question}
                </span>
                <span className="card-label">{" Questions"}</span>
              </>
            )}
          </p>
          <p>
            <img src={CardClockIcon} alt="Duration" className="cardicon" />
            {selectedAssessment.status !== "Resume" ? (
              <>
                <span className="card-value">
                  {selectedAssessment.assessment_duration} Minutes
                </span>
                <span className="card-label">{" Duration"}</span>
              </>
            ) : (
              <>
                {" "}
                <span className="card-value-highlisht-green">
                  {formatTime(selectedAssessment.time_spend)}
                </span>{" "}
                <span className="card-value">
                  / {formatDuration(selectedAssessment.assessment_duration)}
                </span>
              </>
            )}
          </p>
          <p>
            <img src={CardSubIcon} alt="Subject" className="cardicon" />
            <span className="card-label">
              <span className="card-value">
                {(selectedAssessment.dimension_questions ? 1 : 0) +
                  (selectedAssessment.category_list?.length || 0) +
                  (selectedAssessment.curriculum_list?.length || 0)}
              </span>{" "}
              Subject Distribution
            </span>
          </p>
        </div>
        {/* Jozuna */}
        {selectedAssessment.dimension_questions && (
          <div className="card-listsection">
            <p className="card-listheader"> Jozuna: </p>
            <p className="card-listvalue">&#8226; JOZUNA Skills</p>
          </div>
        )}
        {/* Categories */}
        {selectedAssessment.category_list?.length > 0 && (
          <div className="card-listsection">
            <p className="card-listheader"> Curriculum: </p>
            <p className="card-listvalue">
              {selectedAssessment.category_list
                .map((cat: any) => `\u2022 ${cat.category_name}`)
                .join("\n")}
            </p>
          </div>
        )}
        {/* Curriculum */}
        {selectedAssessment.curriculum_list?.length > 0 && (
          <div className="card-listsection">
            <p className="card-listheader">Industry: </p>
            <p className="card-listvalue">
              {selectedAssessment.curriculum_list
                .map((cat: any) => `\u2022 ${cat.category_name}`)
                .join("\n")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssessmentDetailsComponent;
